import { render } from "./transmitted.vue?vue&type=template&id=685b819e&scoped=true"
import script from "./transmitted.vue?vue&type=script&lang=js"
export * from "./transmitted.vue?vue&type=script&lang=js"

import "./transmitted.vue?vue&type=style&index=0&id=685b819e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685b819e"]])

export default __exports__